import { loadAMap } from "./loadSdkScript";
import { getUserCurrentAddress } from "./getUserLocation";
import bezierCurve from "./bezierCurve";

export default class AMapUtils {
  constructor(id) {
    this.map = null;
    this.idStr = id;
    this.markers = [];
    this.drivePathWay = null;
    this.truckPathWay = null;
    this.cityFreightText = null;
    this.ridePathWay = null;
    this.polygonMap = null;
    this.district = null;
    this.mark = null;
    this.placeSearch = null;
    this.geocoder = null;
    this.mouseTool = null;
  }

  static loadAMap() {
    return loadAMap();
  }

  setMap(map) {
    this.map = map;
  }

  destroy() {
    if (!this.map) return;
    this.map.destroy();
    this.map = null;
  }

  getMap() {
    return this.map;
  }

  newMap(center, zoom = 12) {
    return loadAMap().then(() => {
      const map = new AMap.Map(this.idStr, {
        center, // 地图中心点
        zoom, // 地图显示的缩放级别
      });
      this.map = map;
      return map;
    });
  }

  cityMap(zoom = 12, options) {
    return loadAMap().then(() => {
      const map = new AMap.Map(this.idStr, {
        resizeEnable: true,
        expandZoomRange: true,
        zooms: [3, 20],
        zoom, // 地图显示的缩放级别
        ...options,
      });
      this.map = map;
      return map;
    });
  }
  
  /* 两点距离计算 */
  getDistance(start = [], end = []) {
    const startLngLat = new AMap.LngLat(...start)
    const endLngLat = new AMap.LngLat(...end)
    const distance = startLngLat.distance(endLngLat).toFixed(2)
    return distance;
  }

  /* 两点路径距离计算 */
  getRouterDistance(start = [], end = []) {
    const distance = AMap.GeometryUtil.distanceOfLine([start, end]).toFixed(2)
    return distance;
  }

  /* 驾车路线规划 */
  drivePath(start, arr = [], end) {
    // let shopPos = start;
    // let userPos = end;
    // if (typeof start === "string") {
    //   shopPos = start.split(",");
    // }
    // if (typeof end === "string") {
    //   userPos = end.split(",");
    // }
    const path = arr.map(item=>(new AMap.LngLat(...item)))
    if (!this.drivePathWay) {
      this.drivePathWay = new AMap.Driving({
        map: this.map,
        policy: 2,
        autoFitView: true,
      });
    }
    return new Promise((resolve, reject) => {
      this.drivePathWay.search(new AMap.LngLat(...start), new AMap.LngLat(...end), {
        waypoints: path
      }, (status, res) => {
        if (status === "complete") {
          // cb(true, res);
          resolve(res);
        } else {
          reject("路线规划失败");
          // cb(false, '路线规划失败');
        }
      });
    });
  }


  /* 货车路线规划 */
  truckPath(arr = [], params = {}) {
    const path = arr.map(item=>({lnglat:item}))
    if (!this.truckPathWay) {
      this.truckPathWay = new AMap.TruckDriving({
        map: this.map,
        size: 2,
        policy: 2,
        ...params
      });
    }
    
    return new Promise((resolve, reject) => {
      this.truckPathWay.search(path, (status, res) => {
        console.log('this.truckPathWay', status, res);
        if (status === "complete") {
          resolve(res);
        } else {
          reject("路线规划失败", status);
        }
      });
    });
  }

  /**
   * 骑行路线规划
   * @param start 开始坐标
   * @param end 结束坐标
   * @returns {Promise<any>}
   */
  ridePath(start, end) {
    let shopPos = start;
    let userPos = end;
    if (typeof start === "string") {
      shopPos = start.split(",");
    }
    if (typeof end === "string") {
      userPos = end.split(",");
    }
    // const ride = new AMap.Riding({
    //   map: this.map,
    //   policy: 2,
    //   autoFitView: true,
    // });
    if (!this.ridePathWay) {
      this.ridePathWay = new AMap.Riding({
        map: this.map,
        policy: 2,
        autoFitView: true,
      });
    }
    return new Promise((resolve, reject) => {
      this.ridePathWay.search(shopPos, userPos, (status, res) => {
        if (status === "complete") {
          resolve(res);
        } else {
          reject("路线规划失败");
        }
      });
    });
    // ride
  }

  cityText(point, km) {
    let position = point;
    if (typeof point === "string") position = point.split(",");
    if (!this.cityFreightText) {
      this.cityFreightText = new AMap.Text({
        text: `距离${km}km`,
        angle: 10,
        position,
        style: {
          padding: ".2rem 0.4rem",
          "border-radius": ".13rem",
          "background-color": "white",
          "font-size": "14px",
          color: "#333",
          "margin-top": "-1.3rem",
        },
      });
    } else {
      this.cityFreightText.setText(`距离${km}km`);
      this.cityFreightText.setPosition(position);
    }
    this.cityFreightText.setMap(this.map);
  }

  /**
   * 提交订单定位文本标注
   * @param point 【数组】或者'lng,lat'
   * @param km 字符串
   */
  orderMapText(point, { template, style }) {
    let position = point;
    if (typeof point === "string") position = point.split(",");
    if (!this.cityFreightText) {
      const defaultStyle = {
        // 'padding': '.2rem 0.4rem',
        // 'border-radius': '.5rem',
        "background-color": "transparent",
        border: "none",
        // 'font-size': '14px',
        // 'color': '#333',
        "margin-top": "-.4rem",
        "z-index": "202",
      };
      this.cityFreightText = new AMap.Text({
        text: template,
        angle: 0,
        position,
        style: style || defaultStyle,
      });
    } else {
      this.cityFreightText.setText(template);
      this.cityFreightText.setPosition(position);
    }
    this.cityFreightText.setMap(this.map);
  }

  /* 注册点击事件 */
  mapAddEvent(callback) {
    this.map.on("click", (res) => {
      console.log({ res });
      if (callback) {
        callback(res.lnglat.lng, res.lnglat.lat);
      }
    });
  }

  // 定位
  getCurrentAddress(hasMap = false) {
    return new Promise((resolve, reject) => {
      getUserCurrentAddress()
        .then((data) => {
          if (hasMap) {
            this.addPositionMarker(data);
          }
          resolve(data);
        })
        .catch((errMsg) => {
          reject(errMsg);
          // getPositionFileHandler(errMsg, reject);
        });
    });
  }

  addPositionMarker({ lng, lat }) {
    if (!this.map) return;
    const position = [{ lng, lat }];
    this.map.clearMap();
    this.marker(position);
    this.map.setFitView();
  }

  /**
   * 标记店铺
   * @param list
   * @param draggable
   * @param icon
   */
  marker(list, draggable = false, icon, offset = []) {
    list.forEach((item) => {
      this.mark = new AMap.Marker({
        position: [item.map_lon || item.lng || item.location.lng, item.map_lat || item.lat || item.location.lat],
        offset: new AMap.Pixel(offset[0] || -12, offset[1] || -12),
        zIndex: 201,
        title: item.shop_name || "",
        icon,
        map: this.map,
        draggable,
      });
      this.markers.push(this.mark);
    });
  }

  createIcon(width, height, url, offsetX = 0, offsetY = 0, stretchX, stretchY) {
    return new AMap.Icon({
      size: new AMap.Size(width, height),    // 图标尺寸
      image: url,  // Icon的图像
      imageOffset: new AMap.Pixel(offsetX, offsetY),  // 图像相对展示区域的偏移量，适于雪碧图等
      imageSize: new AMap.Size(stretchX || width, stretchY || height)   // 根据所设置的大小拉伸或压缩图片
    });
  }

  addLabelMarker(position, icon, name = "", zIndex = 200, params) {
    return new AMap.LabelMarker({
      name,
      position,
      // offset: new AMap.Pixel(offsetX, offsetY),
      zIndex,
      icon,
      ...params,
    });
  }

  addLabelsLayer(zooms = [3, 20], zIndex = 1000, collision = true, allowCollision = false) {
    return new AMap.LabelsLayer({
      zooms,
      zIndex,
      collision,  // 该层内标注是否避让
      allowCollision, // 设置 allowCollision：true，可以让标注避让用户的标注
    });
  }

  addMaker(position, icon, title = "", offsetX = -12, offsetY = -12, draggable = false, params) {
    return new AMap.Marker({
      position,
      offset: new AMap.Pixel(offsetX, offsetY),
      zIndex: 201,
      title,
      icon,
      map: this.map,
      draggable,
      ...params,
    });
  }
  /**
   * 创建多边形
   * @param path 坐标集，可为数组或者字符串
   * @param fitView 是否地图居中
   * @param draggable 是否拖动
   * @param isEdit 是否绑定编辑，显示，关闭方法
   * @param color 颜色
   */
  polygonCreate(path, fitView = false, draggable = false, isEdit = false, color = "#1791fc") {
    const paths = [];
    path.forEach((item) => {
      if (typeof item === "string") {
        paths.push(item.split(","));
      } else {
        paths.push(item);
      }
    });
    this.polygonMap = new AMap.Polygon({
      path: paths,
      strokeColor: color,
      strokeWeight: 6,
      strokeOpacity: 0.2,
      fillOpacity: 0.4,
      fillColor: color,
      zIndex: 50,
      draggable,
    });
    this.polygonMap.setMap(this.map);
    if (fitView) {
      this.map.setFitView(this.polygonMap);
    }
    if (isEdit) {
      this.polygonMap.modelEditor = new AMap.PolyEditor(this.map, this.polygonMap);
      this.polygonMap.startEdit = () => {
        this.polygonMap.modelEditor.open();
        this.polygonMap.setOptions({ draggable: true });
        return this.polygonMap;
      };
      this.polygonMap.closeEdit = () => {
        this.polygonMap.modelEditor.close();
        this.polygonMap.hide();
        return this.polygonMap;
      };
      this.polygonMap.showModel = () => {
        this.polygonMap.show();
        return this.polygonMap;
      };
    }
  }

  drawCircle(lng, lat, radius, color, strokeColor, fillOpacity, strokeWeight) {
    const circle = new AMap.Circle({
      center: new AMap.LngLat(lng, lat), // 圆心位置
      radius, // 圆半径
      fillColor: color || "#0060FF", // 圆形填充颜色
      strokeColor: strokeColor || "#0060FF", // 描边颜色
      fillOpacity: fillOpacity || 0.2,
      strokeWeight: strokeWeight || 1, // 描边宽度
    });
    this.map.add(circle);
    return circle;
  }

  /**
   * 创建以中心点或者地图中心店圆形
   * @param range 圆圈半径
   * @param draggable 是否能拖动
   * @param centerPoint 自定义中心点
   * @param color
   * @returns {*[]} 返回创建的数组
   */
  polyEditorCreate(range, draggable = false, centerPoint, color = "#1791fc") {
    let tag_x;
    let tag_y;
    if (centerPoint && centerPoint.lng && centerPoint.lat) {
      tag_x = centerPoint.lng;
      tag_y = centerPoint.lat;
    } else {
      tag_x = this.map.G.center.lng;
      tag_y = this.map.G.center.lat;
    }
    const base_x = 0.011714;
    const base_y = 0.0089826;
    const distance_x = base_x * range;
    const distance_y = base_y * range;
    const two_third = Math.sqrt(3) / 2;
    const paths = [
      // 构建多边形经纬度坐标数组
      [tag_x, tag_y + distance_y],
      [tag_x + distance_x / 2, tag_y + distance_y * two_third],
      [tag_x + distance_x * two_third, tag_y + distance_y / 2],
      [tag_x + distance_x, tag_y],
      [tag_x + distance_x * two_third, tag_y - distance_y / 2],
      [tag_x + distance_x / 2, tag_y - distance_y * two_third],
      [tag_x, tag_y - distance_y],
      [tag_x - distance_x / 2, tag_y - distance_y * two_third],
      [tag_x - distance_x * two_third, tag_y - distance_y / 2],
      [tag_x - distance_x, tag_y],
      [tag_x - distance_x * two_third, tag_y + distance_y / 2],
      [tag_x - distance_x / 2, tag_y + distance_y * two_third],
    ];
    this.polygonCreate(paths, true, draggable, true, color);
    this.polygonMap.startEdit();
    return paths;
  }

  removeMarkers() {
    this.map.remove(this.markers);
    // this.map.clearMap();
  }

  removerPolygonMap() {
    this.map.remove(this.polygonMap);
  }

  /**
   * 清除地图所有内容
   */
  clearMaps() {
    this.map.clearMap();
  }

  /**
   * 获取地图中心点并返回
   * @returns {{tag_y: *, tag_x: *}}
   */
  getCenter() {
    return this.map.getCenter();
  }

  /**
   * 设置地图中心点
   */
  setCenter(lng, lat) {
    this.map.setCenter([lng, lat]);
  }

  /**
   * 设置地图缩放等级和中心点
   */
  setZoomAndCenter(zoom, lng, lat) {
    this.map.setZoomAndCenter(zoom, [lng, lat]);
  }

  /**
   * 地图居中
   */
  setFitView() {
    this.map.setFitView();
  }

  /**
   * 根据等级搜索地址
   * @param value 区名称
   * @param district 区域等级，县/区
   * @param color 颜色
   * @returns {Promise<never>|Promise<any>} 返回面积
   */
  searchCity(value, district = "district", color = "#1791fc") {
    if (!this.district) {
      const opts = {
        subdistrict: 0, // 获取边界不需要返回下级行政区
        extensions: "all", // 返回行政区边界坐标组等具体信息
        level: "district", // 查询行政级别为 市
      };
      this.district = new AMap.DistrictSearch(opts);
    }
    if (!value) return Promise.reject();
    this.district.setLevel(district);
    let area = 0;
    return new Promise((resolve, reject) => {
      this.district.search(value, (status, result) => {
        this.clearMaps();
        if (!result.districtList) {
          reject();
          return;
        }
        this.polygonCreate(result.districtList[0].boundaries, true, false, false, color);
        // const mouseTool = new AMap.MouseTool(this.map);
        // result.districtList[0].boundaries;
        AMap.plugin("AMap.GeometryUtil", () => {
          result.districtList[0].boundaries.forEach((item) => {
            area += AMap.GeometryUtil.ringArea(item);
          });
          resolve({
            range: result.districtList[0].boundaries,
            acreage: area,
          });
        });
      });
    });
  }

  /**
   * 搜索地址
   * @param value
   * @returns {string|Promise<any>}
   */
  search(value, cityCode, pageSize = 10, pageIndex = 1) {
    if (value === "") return Promise.reject();
    return new Promise((resolve, reject) => {
      AMap.service(["AMap.PlaceSearch"], () => {
        this.placeSearch = new AMap.PlaceSearch({
          pageSize,
          pageIndex,
          city: cityCode,
        });
        this.placeSearch.search(value, (status, result) => {
          if (status === "complete") {
            resolve(result.poiList);
          } else if (status === "no_data") {
            reject("结果为空");
          } else {
            console.log(status, result);
            reject("搜索失败");
          }
        });
      });
    });
  }

  searchNearByPoint(point, addMarker = true) {
    return new Promise((resolve, reject) => {
      AMap.service(["AMap.PlaceSearch"], () => {
        const placeSearch = new AMap.PlaceSearch({
          pageSize: 10,
          pageIndex: 1,
          // city,
          map: addMarker ? this.map : undefined,
        });
        console.log("serch nearby", point);
        placeSearch.searchNearBy("", point, 1000, (status, res) => {
          if (status === "complete") {
            resolve(res.poiList);
          } else if (status === "no_data") {
            reject("结果为空");
          } else {
            reject([]);
          }
        });
      });
    });
  }

  /**
   * 清除搜索地址
   */
  placeSearchClear() {
    console.log(this.placeSearch, 1);
    this.placeSearch.clear();
  }

  /**
   * 根据坐标获取地址name
   * @param item
   * @returns {Promise<any>}
   */
  getAddress(item) {
    const position = [item.map_lon || item.location.lng, item.map_lat || item.location.lat];
    const that = this
    return new Promise((resolve, reject) => {
      AMap.service(["AMap.Geocoder"], () => {
        this.geocoder = new AMap.Geocoder({ ...this.map });
        this.geocoder.getAddress(position, (status, result) => {
          if (status === "complete" && result.info === "OK") {
            // this.platInfo.address = result.regeocode.formattedAddress;
            // console.log(result, '=======> getAddress')
            let {
              province,
              city,
              district,
              street,
              streetNumber,
              neighborhood
            } = result.regeocode.addressComponent
            let address = province + city + district + street + streetNumber
            if(!neighborhood){
              that.search(result.regeocode.formattedAddress,'510100').then(res => {
                resolve({address, abbreviation: res.pois[0].name });
              })
              return
            }
            resolve({address, abbreviation: neighborhood });
          } else {
            reject("地址获取失败");
          }
        });
      });
    });
  }

  /**
   * 获取当前城市
   * @returns {Promise<any>}
   */
  getCity() {
    return new Promise((resolve, reject) => {
      loadAMap().then(()=>{
        const city = new AMap.CitySearch();
        city.getLocalCity((status, result) => {
          if (status === "complete" && result.info === "OK") {
            resolve(result);
          } else {
            reject("城市获取失败");
          }
        });
      })
    });
  }

  /**
   * 获取城市定位
   * @param city
   * @returns {Promise<any>}
   */
  getCityLocation(city) {
    return new Promise((resolve, reject) => {
      this.geocoder = new AMap.Geocoder({ city });
      this.geocoder.getLocation(city, (status, result) => {
        if (status === "complete" && result.info === "OK"&&result.geocodes[0]) {
          
          resolve(result.geocodes[0]);
        } else {
          reject("地址获取失败");
        }
      });
    });
  }

  /**
   * @param {*} startP 开始经纬度
   * @param {*} endP 结束经纬度
   * @param {*} centerContent 信息弹框展示的内容
   * @param {*} distributionType 订单配送类型 1第三方 2商家自配送
   * @return {*}
   */

  addLine(startP, endP, centerContent, distributionType) {
    const { pathArr, lineCenterPoint } = bezierCurve(startP, endP);
    const centerPoint = lineCenterPoint; // 获取两经纬度 中间经纬度
    if (distributionType === 2) {
      this.addInfoModel(centerPoint, centerContent, -6, -6); // 添加自定义信息框
    }
    if (pathArr.length < 1) return;
    const bz = new AMap.BezierCurve({
      path: pathArr,
      strokeWeight: 10, // 线条宽度
      strokeColor: "rgba(246,63,41,0.5)", // 线条颜色
      strokeStyle: "solid", // 线样式
      showDir: true, // 是否显示箭头
    });
    this.map.add(bz); // 绘制两点弧线
  }

  /**
   * @description: 自定义 标记
   * @param {*} position 经纬度
   * @param {*} content 自定义内容
   * @param {*} type 1 用户 2 商家骑手 3中心点样式
   * @return {*}
   */
  customAddMaker(position, content, title = "", offsetX = -30, offsetY = -30, draggable = false) {
    if (!position[0] || !position[1]) {
      return null;
    }
    return new AMap.Marker({
      position,
      offset: new AMap.Pixel(offsetX, offsetY),
      zIndex: 201,
      title,
      content,
      map: this.map,
      draggable,
    });
  }

  addText(t, position, params) {
    // 构建纯文本标记
    const text = new AMap.Text({
      text: t,
      position,
      topWhenClick: true,
      ...params
    });
    text.setMap(this.map);
    return text;
  }

  addInfoModel(port, content, offsetX = 0, offsetY = 0, params) {
    // 构建自定义信息窗体
    const infoWindow = new AMap.InfoWindow({
      anchor: "top-left",
      content,
      offset: new AMap.Pixel(offsetX, offsetY),
      retainWhenClose: true,
      ...params,
    });
    infoWindow.open(this.map, port);
    return infoWindow;
  }
  //绘制多边形
  drawPolygons(callback) {
    AMap.plugin("AMap.MouseTool", () => {
      console.log("AMap.MouseTool");
      this.mouseTool = new AMap.MouseTool(this.map);
      this.mouseTool.on("draw", callback);
      this.mouseTool.polygon({
        fillColor: "#00b0ff",
        strokeColor: "#80d8ff",
      });
    });
  }
  //点连线
  pointAttachment(path, strokeColor, strokeWeight, params) {
    let polyline = new AMap.Polyline({
      path,
      strokeColor: strokeColor || "#4794ef",
      strokeWeight: strokeWeight || "4",
      ...params,
    });
    polyline.setMap(this.map);
    return polyline;
  }
  //获取区域的marker
  getContentMarker() {
    return this.map.getAllOverlays("marker").reduce((pop, item) => {
      if (this.map.getBounds().contains(new AMap.LngLat(item.De.position.lng, item.De.position.lat))) {
        return pop + 1;
      }
      return pop;
    }, 0);
  }
}
